<template>
    <slot
        :errors="BstkCSVImportData.errors"
        :fields="BstkCSVImportData.fields"
        :file="BstkCSVImportData.file"
    ></slot>
</template>

<script>
    import {computed, reactive, provide} from 'vue';
    import drop from 'lodash/drop';
    import every from 'lodash/every';
    import forEach from 'lodash/forEach';
    import get from 'lodash/get';
    import isArray from 'lodash/isArray';
    import map from 'lodash/map';
    import set from 'lodash/set';
    import merge from 'lodash/merge';

    const defaultLanguage = {
        errors: {
            fileRequired: 'A file is required',
            invalidMimeType: "Invalid file type"
        },
        toggleHeaders: 'File has headers',
        toggleMissing: 'Create missing records',
        submitBtn: 'Submit',
        fieldColumn: 'Field',
        csvColumn: 'Column'
    };

    const mapFields = function (fields) {
        if (isArray(fields)) {
            return map(fields, (item) => {
                return {
                    key: item,
                    label: item,
                    required: true
                };
            });
        }

        return map(fields, (val, key) => {
            return {
                key: key,
                label: get(val, 'label', val),
                required: get(val, 'required', true),
            };
        });
    }

    export default {
        /* eslint-disable */
        props: {
            modelValue: Array,
            fields: {
                type: [Object, Array],
                required: true
            },
            fileHasHeaders: Boolean,
            addNewRecords: Boolean,
            text: {
                default() {
                    return {};
                }
            }
        },
        emits: ["update:modelValue"],
        setup(props, {emit}) {
            let BstkCSVImportData = reactive({
                errors: [],
                inputName: 'csv',
                file: null,
                map: {},
                value: {},
                fields: mapFields(props.fields),
                fileHasHeaders: props.fileHasHeaders,
                addNewRecords: props.addNewRecords,
                csvSample: null,
                rawCsv: null,
                language: merge({}, defaultLanguage, props.text),
                firstSampleRow: computed(() => isArray(BstkCSVImportData.csvSample) && isArray(BstkCSVImportData.csvSample[0]) ? BstkCSVImportData.csvSample[0] : null),
                allFieldsAreMapped: computed(() => every(BstkCSVImportData.fields, function (field) {
                    return typeof BstkCSVImportData.map[field.key] !== 'undefined' || !field.required;
                })),
            });

            const buildMappedCsv = function () {
                let newCsv = BstkCSVImportData.fileHasHeaders ? drop(BstkCSVImportData.rawCsv) : BstkCSVImportData.rawCsv;

                BstkCSVImportData.value = map(newCsv, (row) => {
                    let newRow = {};
                    forEach(BstkCSVImportData.map, (column, field) => {
                        set(newRow, field, get(row, column));
                    });
                    set(newRow, 'action', (BstkCSVImportData.addNewRecords ? 'replace' : 'update'));
                    set(newRow, 'status', '-');

                    return newRow;
                });

                emit('update:modelValue', BstkCSVImportData.value);
            };

            provide('BstkCSVImportData', BstkCSVImportData);
            provide('buildMappedCsv', buildMappedCsv);

            return {
                BstkCSVImportData
            };
        }
    };
</script>